import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { DashboardService } from "./service";
import { ErrorToast } from "../../shared/toasters/toasters";
import { useTranslation } from "react-i18next";
import { Row } from "react-bootstrap";
import CompanyStatisticsTable from "../../shared/components/CompanyStatisticsTable";
import JobStatisticsTable from "../../shared/components/JobStatisticsTable";
import CoachStatisticsTable from "../../shared/components/CoachStatisticsTable";
import SubscriptionStatisticsTable from "../../shared/components/SubscriptionStatisticsTable";
import LandingDashboard from "../landing";
import MonthlyGraphs from "./MonthlyGraphs";

const Dashboard = () => {
    const { t } = useTranslation();
    const auth = useContext(AuthContext);
    const [statistics, setStatistics] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    if (!auth) {
        throw new Error('AuthContext must be used within an AuthProvider');
    }

    const { user, logout } = auth;

    useEffect(() => {
        const fetchStatistics = async () => {
            try {
                const response = await DashboardService.getStatistics();
                setStatistics(response);
            } catch (error) {
                ErrorToast(error);
            } finally {
                setLoading(false);
            }
        };

        fetchStatistics();
    }, []);

    if (loading) {
        return <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>;
    }

    return (
        <>
            <LandingDashboard />
            <MonthlyGraphs />
            <Row>
                <CompanyStatisticsTable data={statistics?.companyStatistics} />
                <JobStatisticsTable data={statistics?.jobStatistics} />
                <CoachStatisticsTable data={statistics?.coachStatistics} />
                <SubscriptionStatisticsTable data={statistics?.subscriptionStatistics} />
            </Row>
        </>
    );
}

export default Dashboard